import React from 'react';
import axios from 'axios';

import { useModal } from '../Components/Modal/ModalContext';

import styles from '../styles/DynamicModal.module.css';

const ChangeRegionModal = ({ closeModal, id, onReloadTable }) => {
    const { openModal } = useModal();
    const [warning, setWarning] = React.useState('');
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [region, setRegion] = React.useState('');
    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            axios.get(`/api/region?id=${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                setRegion(response.data.name);

                setLoading(false);
            }).catch(err => {
                console.error('Ошибка получения данных '+err);
                setWarning('Ошибка получения данных: '+err.message);
                setLoading(false);
            });
        } else {
            handleLogout();
        }
    }, []);

    const changeData = async (e) => {
        e.preventDefault();

        const response = await axios.put(`/api/region`, {
            id,
            name: region
        })
        .then((response) => {
            if (response.status == 200) {
                setStatus('Название региона успешно изменено.');
            } else {
                setStatus('Ошибка изменения названия региона.');
            }
        })
        .catch((err) => { 
            setStatus('Ошибка обновления данных: ' + (err.response.data));
        });
    }


    return (
        <div className={styles.liningOver} onClick={() => {closeModal(); onReloadTable()}}>
            <form className={styles.lining} onClick={(e) => e.stopPropagation()} onSubmit={(e) => changeData(e)}>
                <div className={styles.header}>
                    <div style={{display: 'flex', maxWidth: '80%'}}>
                        <h1>Изменить название региона</h1>
                    </div>
                    <svg onClick={() => {closeModal(); onReloadTable()}} viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                    {loading ? (
                        <a style={{width: '30px'}}><svg viewBox='0 0 200 200'><circle fill='#444444' stroke='#444444' strokeWidth='2' r='15' cx='40' cy='65'><animate attributeName='cy' calcMode='spline' dur='2' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.4'></animate></circle><circle fill='#444444' stroke='#444444' strokeWidth='2' r='15' cx='100' cy='65'><animate attributeName='cy' calcMode='spline' dur='2' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.2'></animate></circle><circle fill='#444444' stroke='#444444' strokeWidth='2' r='15' cx='160' cy='65'><animate attributeName='cy' calcMode='spline' dur='2' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='0'></animate></circle></svg></a>
                    ) : warning ? (
                        <a>{warning}</a>
                    ) : (
                        <span style={{width: '320px', margin: '0 auto'}}>
                            <a style={{display: 'flex', justifyContent: 'center'}}>Измените название</a>
                            <input type="text" placeholder='Введите новое название' value={region} onChange={(e) => {setRegion(e.target.value)}} />
                            {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                            <button className='button maxWidth' type='submit'>Подтвердить изменение названия</button>
                        </span>
                    )}
                </div>
            </form>
        </div>
    )
}

export default ChangeRegionModal;